<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>内容管理</span>
                </div>
            </div>
            <el-form label-width="100px" :model="actData" ref="formRule" :rules="formRule">
                <el-form-item label="类型" prop="type">
                    <el-select v-model="actData.type" placeholder="请选择类型">
                        <el-option :label="value" :value="key" v-for="(value, key) in typeData" :key="key + '231'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="语言">
                    <el-select v-model="actData.lang" placeholder="请选择语言">
                        <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签" prop="tags">
                    <el-select v-model="actData.tags" placeholder="请选择标签">
                        <el-option :label="item" :value="item" v-for="item in tags" :key="item + '2312'"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input v-model="actData.title" maxlength="100" placeholder="请输入标题"></el-input>
                </el-form-item>
                <el-form-item label="封面" prop="cover_image">
                    <el-upload
                        class="upload_box"
                        action=""
                        :http-request="uploadFile"
                        :show-file-list="false"
                        accept="image/*"
                        >
                        <img v-if="imageUrl" :src="imageUrl" class="banner_img">
                        <i v-else class="el-icon-plus banner_icon"></i>
                        <!-- <div slot="tip" class="el-upload__tip">{{`（请使用${actData.banner_type == 'scrolling' ? '21:9' : '305*380'}的图片）`}}</div> -->
                    </el-upload>
                </el-form-item>
                <el-form-item label="跳转链接" prop="link_url">
                    <el-input v-model="actData.link_url" placeholder="请输入跳转链接"></el-input>
                </el-form-item>
                <el-form-item label="排序号" prop="sort_order">
                    <el-input v-model.number="actData.sort_order" placeholder="请输入排序号"></el-input>
                </el-form-item>
                <el-form-item>
                    <div class="btn">
                        <div class="button" @click="updateConfirm">
                            <span>提交</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default({
    name: 'community-tag',
    data() {
        return {
            communityId: '',
            typeData: {
                banner: '活动',
                article: '文章',
                multi_image: '图文',
                video: '视频',
            },
            tags: [],
            actData: {
                lang: 'zh',
            },
            imageUrl: '',
            formRule: {
                type: [this.requiredRule('请选择类型')],
                title: [this.requiredRule('请输入标题')],
                link_url: [this.requiredRule('请输入跳转连接')],
                cover_image: [this.requiredRule('请选择图片')],
            },
        }
    },
    watch: {
    },
    created() {
        
    },
    activated() {
        this.getTags();
        this.communityId = this.$route.query.id;
        this.actData = {
            lang: 'zh',
        };
        if(this.communityId) {
            this.getCommunity();
        }
    },
    methods: {
        getTags() {
            this.api.getCommunityTags({}).then(data => {
                this.tags = data.data.split(',');
            })
        },
        getCommunity() {
            this.api.getCommunityList({id: this.communityId}).then(data => {
                this.actData = data.data.list[0];
                this.imageUrl = data.data.list[0].cover_image_sign;
            })
        },
        uploadFile(file) {
            /*
                上传alioss 上传展示的文件需要转成blob 创建链接展示
                上传alioss接口uploadAliOss，第一个参数为oss存储地址+文件名字，第二个参数为上传的文件
            */
            this.imageUrl = window.URL.createObjectURL(new Blob([file.file]));
            const timestamp = new Date().getTime();
            this.uploadAliOss(`op/app/banner/${this.formDate(timestamp, 'YYYYMMDD')}/${timestamp+'_'+file.file.name}`, file.file).then(data => {
                this.actData.cover_image = decodeURIComponent((data[0].split('aliyuncs.com/')[1]).split('?')[0]);
                this.$refs.formRule.validateField('banner_pic');
            }).catch(data => {
                this.imageUrl = actData.cover_image_sign || '';
                this.$message.success('文件上传失败，请稍后重试!');
            });
        },
        updateConfirm() {
            this.$refs.formRule.validate(v => {
                if(v) {
                    let actData = {...this.actData};
                    actData.sort_order = actData.sort_order ? actData.sort_order : 0;
                    this.api.communityUpdate(this.actData).then(data => {
                        if(data.code == 0 || data.code == 200) {
                            this.$message.success('操作成功！');
                        }
                    })
                }
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .el-form{
        max-width: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/view/app/community/content-manage.vue